import { CATALOGUE_EVENTS } from '../../event_bus_modules/properties_in_catalogue';
import { createUniqueCountdownElement } from '../../utils/unique_elements';

$(() => {
  const entityId = $('#_entity-id').val();
  const secondsToRegistrationEnabled =
    parseInt($('#_seconds-to-registration-enabled').val()) || 0;
  const isUserAuthenticated = $('#_is-user-authenticated').val() === 'True';

  const REGISTRATION_BUTTON_SECTION = {
    USER_NOT_AUTHENTICATED: $(
      '.registration-button-section--user-not-authenticated'
    ),
    USER_NOT_REGISTERED_TO_LOT: $(
      '.registration-button-section--user-not-registered-to-lot'
    ),
    USER_ALREADY_REGISTERED_TO_LOT: $(
      '.registration-button-section--user-already-registered-to-lot'
    ),
    AUCTION_LOT_ALREADY_IN_CART: $(
      '.registration-button-section--auction-lot-already-in-cart'
    ),
    REGISTRATION_NOT_YET_OPEN: $(
      '.registration-button-section--registration-not-yet-open'
    ),
  };

  const REGISTER_TO_BID_FORM = REGISTRATION_BUTTON_SECTION.USER_NOT_REGISTERED_TO_LOT.find(
    'form'
  );
  const REGISTER_TO_BID_BUTTON = REGISTER_TO_BID_FORM.find(
    'button[type="submit"]'
  );

  const onAddedToCatalogue = (id, entityType) => {
    if (entityId == id) {
      REGISTRATION_BUTTON_SECTION.USER_NOT_REGISTERED_TO_LOT.hide();
      REGISTRATION_BUTTON_SECTION.AUCTION_LOT_ALREADY_IN_CART.show();
    }
  };

  const onRemovedFromCatalogue = (id, entityType) => {
    if (entityId == id) {
      REGISTRATION_BUTTON_SECTION.AUCTION_LOT_ALREADY_IN_CART.hide();
      REGISTRATION_BUTTON_SECTION.USER_NOT_REGISTERED_TO_LOT.show();
    }
  };

  const onCountdownFinish = () => {
    REGISTRATION_BUTTON_SECTION.REGISTRATION_NOT_YET_OPEN.hide();
    if (isUserAuthenticated) {
      REGISTRATION_BUTTON_SECTION.USER_NOT_REGISTERED_TO_LOT.show();
    } else {
      REGISTRATION_BUTTON_SECTION.USER_NOT_AUTHENTICATED.show();
    }
  };

  const runCountdownToRegistrationEnabled = () => {
    const registrationCountdownElement = createUniqueCountdownElement();
    const deadline = new Date();
    deadline.setHours(
      deadline.getHours(),
      deadline.getMinutes(),
      deadline.getSeconds() + secondsToRegistrationEnabled
    );

    registrationCountdownElement
      .countdown(deadline)
      .on('finish.countdown', onCountdownFinish);
  };

  if (secondsToRegistrationEnabled > 0) {
    runCountdownToRegistrationEnabled();
  }

  // by default, register to bid & Add to cart buttons are disabled, enable it after page is loaded
  REGISTER_TO_BID_BUTTON.removeAttr('disabled');

  EVENT_BUS.on(
    CATALOGUE_EVENTS.REMOVED_FROM_CATALOGUE,
    ({ id, entity_type }) => {
      onRemovedFromCatalogue(id, entity_type);
    }
  );

  EVENT_BUS.on(CATALOGUE_EVENTS.ADDED_TO_CATALOGUE, ({ id, entity_type }) => {
    onAddedToCatalogue(id, entity_type);
  });
});
